export default "__VITE_ASSET__exx8vp30__"